import { Design } from 'src/app/shared/models/design.model';

export const MAX_RECENT_DESIGNS = 10;

export function mergeRecentDesigns(designs: readonly Design[], excludedDesignId?: string): Design[] {
  const seen = new Set<string>();

  return designs.filter(design => {
    if (!design?.id || design.id === excludedDesignId || seen.has(design.id)) {
      return false;
    }

    seen.add(design.id);
    return true;
  }).slice(0, MAX_RECENT_DESIGNS);
}

export function rememberRecentDesign(designs: readonly Design[], design: Design, excludedDesignId?: string): Design[] {
  return mergeRecentDesigns([design, ...designs], excludedDesignId);
}
